import { render, staticRenderFns } from "./WishDetails.vue?vue&type=template&id=16325219"
import script from "./WishDetails.vue?vue&type=script&lang=js"
export * from "./WishDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports